// src/redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import { saveState, loadState } from '../utils/localStorage'; // Import local storage utility functions
import authSlice, { AuthState } from './authSlice'; // Make sure to import AuthState type
import loaderReducer from './loaderSlice';
import toastReducer from './toastSlice';

// Load the initial state from local storage
const preloadedState: { auth: AuthState } = loadState() || { auth: { /* your initial auth state */ } }; // Initialize with your default state if null

const store = configureStore({
  reducer: {
    auth: authSlice,
    loader: loaderReducer, 
    toast: toastReducer
  },
  preloadedState, // Load state
});

// Subscribe to store updates and save the state to local storage
store.subscribe(() => {
  saveState({
    auth: store.getState().auth, // Save only the necessary parts of the state
  });
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
